module.exports = "//static.hsappstatic.net/pricing-pages-ui-components/static-1.7121/js/productIcon/inbound/SalesHub.svg"